import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, DialogContent} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import JsonScreen from "../index";
import SchemaDesigner from "../../SchemaDesigner";
import MenuDesigner from "../../MenuDesignerNew";
import {useLocation} from "react-router-dom";
import {useHistory} from "react-router";

const useStyles = makeStyles(() => ({
    dialogRootPaper: {},
    dialogRoot: {
        padding: 0
    },
    contentRoot: {
        padding: 0,
        '&:first-child': {
            padding: 0
        }
    }
}));

const PopupScreen = (props) => {
    const {
        match,
        closePopUp,
        returnValue,
        screenName,
        state,
        setUpdateTrue,
        inParam,
        doActions
    } = props;
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const isOpen = Boolean(screenName);

    return (
        <Dialog
            anchor={"right"}
            classes={{paper: classes.dialogRootPaper, root: classes.dialogRoot}}
            open={isOpen}
            onClose={() => closePopUp(true)} maxWidth={"xl"}>
            <DialogContent classes={{root: classes.contentRoot}}>
                {isOpen && (
                    <CustomRouting
                        match={match}
                        closePopUp={closePopUp}
                        returnValue={returnValue}
                        isPopUp={true}
                        setUpdateTrue={setUpdateTrue}
                        screenName={screenName}
                        popUpState={{
                            globalValues: state.globalValues,
                            screenName,
                            inParam,
                        }}
                        location={{
                            ...location,
                            state: {...location.state}
                        }}
                        history={history}
                        doActions={doActions}
                    />
                )}
            </DialogContent>
        </Dialog>
    )
};
export default PopupScreen;

PopupScreen.propTypes = {
    computedMatch: PropTypes.string,
    closePopUp: PropTypes.func.isRequired,
    returnValue: PropTypes.func,
    screenName: PropTypes.string,
    state: PropTypes.object.isRequired,
    setUpdateTrue: PropTypes.func,
    inParam: PropTypes.object
};

const CustomRouting = (props) => {
    const {
        screenName, match, closePopUp, setUpdateTrue,
        location, history, returnValue, popUpState, doActions
    } = props;
    switch (screenName) {
        case 'schemaDesigner':
            return <SchemaDesigner match={match}
                                   returnValue={returnValue}
                                   closePopup={closePopUp}
                                   isPopup={true}
                                   inParam={popUpState.inParam['schemaDesigner']}
                                   doActions={doActions}
            />;
        case 'menuDesigner':
            return <MenuDesigner match={match}
                                 returnValue={returnValue}
                                 closePopup={closePopUp}
                                 isPopup={true}
                                 inParam={popUpState.inParam['menuDesigner']}
            />;
        default:
            return (<JsonScreen match={match}
                                popUpState={popUpState}
                                closePopUp={closePopUp}
                                returnValue={returnValue}
                                isPopUp={true}
                                setUpdateTrue={setUpdateTrue}
                                location={location}
                                history={history}
                                doActions={doActions}
            />)
    }
};